<template>
  <!-- rightshares -->
  <div class="w3-container w3-small" id="rightshares">
    <div class="w3-hide-large" style="margin-top:80px"></div>
    <h1 class="w3-xxlarge w3-text-black">
      <b>Right Shares.</b>
    </h1>
    <hr style="width:50px;border:5px solid black" class="w3-round" />
    <div></div>
    <div class="w3-clear">
      <div class="w3-responsive">
        <table class="w3-table-all">
          <caption @if="rightshares" style="text-align:left; font-size:medium">
            Right Shares
          </caption>
          <thead class="w3-gray">
            <th class="nowrap">Stock Symbol</th>
            <th class="w3-align-right nowrap">Ratio</th>
            <th class="w3-align-right nowrap">Units</th>
            <th class="nowrap">Opening Date</th>
            <th class="nowrap">Closing Date</th>
            <th class="nowrap">Book Close Date</th>
            <th class="nowrap">Action</th>
          </thead>
          <tbody>
            <tr v-show="rightsharesloading">
              <td colspan="6">Loading...</td>
            </tr>
            <tr v-show="rightsharesmessage">
              <td colspan="6">{{ rightsharesmessage }}</td>
            </tr>
            <tr
              v-show="!rightsharesloading"
              v-for="rightshare in rightshares"
              v-bind:key="rightshare.stockSymbol + rightshare.openDate"
            >
              <td class="nowrap">
                <span :title="rightshare.companyName">{{
                  rightshare.stockSymbol
                }}</span>
              </td>
              <td class="w3-right-center nowrap">{{ rightshare.ratio }}</td>
              <td class="w3-right-align nowrap">{{ rightshare.units }}</td>
              <td class="nowrap">{{ rightshare.openDate }}</td>
              <td class="nowrap">{{ rightshare.closeDate }}</td>
              <td class="nowrap">{{ rightshare.bookCloseDate }}</td>
              <td>
                <button @click="exportText(rightshare)">
                  <i class="fa fa-download"></i>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import DataService from "@/services/DataService";
import { saveAs } from "file-saver";
import moment from "moment";
export default {
  name: "rightshare",
  components: {},
  data() {
    return {
      rightshares: [],
      rightsharesloading: false,
      rightsharesmessage: "",
    };
  },
  methods: {
    async getrightshares() {
      this.rightsharesloading = true;
      this.rightsharesmessage = "";
      const response = await DataService.getRightSharesFromApi();
      if (response.data) {
        this.rightshares = response.data;
        if (this.rightshares.length > 0) {
          this.rightsharesmessage = "";
        } else {
          this.rightsharesmessage = "No Data Found";
        }
      }
      this.rightsharesloading = false;
    },
    formatDate(date) {
      return moment(String(date), "YYYY-MM-DD").format("YYYYMMDD");
    },
    exportText(rightshare) {
      var date = this.formatDate(new Date().toISOString().slice(0, 10));
      var ratiosplit = rightshare.ratio.split(":");
      var blob = new Blob(
        [
          `SegName                         :NRIGHTMMDD.TXT
Date                            :${date}
Stock Code                      :${rightshare.stockSymbol}
Security Short Name             :${rightshare.companyName}
Ex-Date (Book Closure Date)     :${this.formatDate(rightshare.bookCloseDate)}
Record Date                     :${this.formatDate(
            moment(rightshare.bookCloseDate, "YYYY-MM-DD")
              .add(-1, "days")
              .toISOString()
          )}
New Ratio                       :${rightshare.ratio} Which means ${
            ratiosplit[1]
          } extra share for every ${ratiosplit[0]} shares
Old Ratio                       :${rightshare.oldRatio}
Rights Price                    :Rs.100/- each share.
Subscription Period             :${this.formatDate(rightshare.openDate)} to ${
            rightshare.closeDate == null
              ? ""
              : this.formatDate(rightshare.closeDate)
          }
Subscription units		:${Number(rightshare.units).toLocaleString()} units`,
        ],
        {
          type: "text/plain;charset=utf-8",
        }
      );
      saveAs(blob, `NRIGHTS-${date}-${rightshare.stockSymbol}.txt`);
    },
  },
  created() {
    this.getrightshares();
  },
};
</script>

<style></style>
